<template>
  <div class="home">
    <div class="columns is-multiline is-mobile">
      <div class="column is-4-tablet is-6-mobile is-3-desktop">
        <a href="https://ocr.lapi.mx" target="_blank">
          <div class="square-icon-box is-danger">
            <div class="icon-box-wrapper">
              <b-icon class="icon-box"
                      icon="file-pdf">
              </b-icon>
            </div>
            <div class="box-title">
              OCR
            </div>
            <div class="box-text">
              PDF a Excel
            </div>
          </div>
        </a>
      </div>
      <div class="column is-4-tablet is-6-mobile is-3-desktop">
        <home-cards-item
          prefix="sedena"
          :data="{name: 'sedena-tools-import', icon: 'file-import', color:'is-primary',route:{name:'sedena-tools-import'},exact: false,onlyLapi: false}"
        ></home-cards-item>
      </div>

      <div class="column is-4-tablet is-6-mobile is-3-desktop">
        <home-cards-item
          prefix="sedena"
          :data="{name: 'sedena-tools-pos', icon: 'store', color:'is-twitter',route:{name:'sedena-tools-pos'},exact: false,onlyLapi: false}"
        ></home-cards-item>
      </div>
    </div>
  </div>
</template>

<script>
import HomeCardsItem from "@/components/dashboard/HomeCardsItem";

export default {
  name: "Index",
  components: { HomeCardsItem },
  computed: {
    cardLinks() {
      return this.$store.state.tools.links || [];
    }
  },
  mounted() {
//    console.log(this.$store.state.menu.menuApps);
    if (this.$store.state.menu.menuApps) {
      this.$store.commit("toggleMenuApps");
    }
  }
};
</script>

<style scoped>

</style>